export const BREAKPOINT_PRIORITY = ['mobile', 'tablet', 'desktop', 'lg-down', 'lg', 'xl-down', 'xl'];

export const INPUTMASK = {
  email: {
    alias: 'email',
    placeholder: '_',
    showMaskOnHover: true,
    showMaskOnFocus: true,
    clearIncomplete: false,
    onBeforePaste(pastedValue) {
      return pastedValue.trim();
    },
    // onUnMask(maskedValue, unmaskedValue) {
    //     return unmaskedValue.length > 0 ? maskedValue : unmaskedValue;
    // }
  },
  number: {
    alias: 'numeric',
    rightAlign: false,
    allowMinus: false,
    placeholder: '',
  },
  date: {
    alias: 'datetime',
    inputFormat: 'mm/dd/yyyy',
    placeholder: 'MM/DD/YYYY',
  },
  year: {
    mask: '9999',
    placeholder: '',
    // alias: 'datetime',
    // inputFormat: 'yyyy',
    // placeholder: '_',
    // autoUnmask: true
  },
  currency: {
    alias: 'numeric',
    prefix: '',
    groupSeparator: ',',
    radixPoint: '.',
    digits: 0,
    autoGroup: true,
    rightAlign: false,
    allowMinus: false,
    placeholder: '',
  },
};

export const ITI_ERRORS = {
  1: 'Invalid country code',
  2: 'Too short',
  3: 'Too long',
  4: 'Not a number',
};
